import {BaseQueryFn} from '@reduxjs/toolkit/query';

import createHttpRequest, {HttpRequestType} from '../http';
import IApiViolation from '../model/IApiViolation';

export interface IHttpBaseQueryMeta {
    violations?: IApiViolation[],
}

const httpBaseQuery = (): BaseQueryFn<
    HttpRequestType,
    unknown,
    unknown,
    {},
    IHttpBaseQueryMeta
    > =>
    // eslint-disable-next-line no-unused-vars
    async(args: HttpRequestType, api) => {
        try {
            const result = await createHttpRequest(args);
            return {data: result.data};
        } catch (httpErr: any) {
            if (httpErr?.violations) {
                return {
                    error: httpErr.message,
                    meta: {violations: httpErr.violations},
                };
            }

            return {
                error: httpErr.message,
            };
        }
    };

export default httpBaseQuery;